import type { CreateCarouselBannerInput } from "src/features/HomepageCarouselBanners/models";

import { CreateCarouselBannerForm } from "src/features/HomepageCarouselBanners/components/CreateCarouselBannerForm";
import { useCreateCarouselBanner } from "src/features/HomepageCarouselBanners/hooks/useCreateCarouselBanner";
import normalizeUrl from "src/features/HomepageCarouselBanners/utils/normalizeUrl";

const CreateCarouselBanner = () => {
	const { mutate: createCarouselBanner } = useCreateCarouselBanner();

	const onValid = (data: CreateCarouselBannerInput) => {
		if ("webLink" in data) {
			createCarouselBanner({
				...data,
				webLink: data.webLink ? normalizeUrl(data.webLink) : data.webLink
			});
		} else {
			createCarouselBanner(data);
		}
	};

	return (
		<CreateCarouselBannerForm
			onValid={onValid}
			defaultValues={{ template: "fullImageBanner" }}
		/>
	);
};

export default CreateCarouselBanner;
